<template>
  <div class="compose-widget-list" aria-label="Dashboard 控件选择">
    <div v-if="widgets.length" class="cw-card">
      <div class="cw-card-hd">选择控件</div>
      <select
        class="cw-select"
        :value="selectValue"
        @change="onSelectChange($event)"
      >
        <option value="">（未选中）</option>
        <option v-for="w in widgets" :key="w.id" :value="w.id">{{ optionText(w) }}</option>
      </select>
    </div>
    <div v-else class="cw-card cw-card--muted">
      <div class="cw-card-hd">选择控件</div>
      <p class="cw-empty">暂无控件，请从浮动控件库添加</p>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import type { WidgetDef } from '@/types/dashboardConfig'
import { WIDGET_TYPE_LABELS } from './dashboardComposeDefaults'

const props = defineProps<{
  widgets: WidgetDef[]
  selectedId: string | null
}>()

const emit = defineEmits<{
  select: [id: string]
}>()

const labels = WIDGET_TYPE_LABELS

const selectValue = computed(() => {
  const id = props.selectedId
  if (!id) return ''
  return props.widgets.some((w) => w.id === id) ? id : ''
})

function displayLabel(w: WidgetDef) {
  return (w.label && w.label.trim()) || w.type
}

function optionText(w: WidgetDef) {
  return `${displayLabel(w)} · ${labels[w.type]}`
}

function onSelectChange(e: Event) {
  emit('select', (e.target as HTMLSelectElement).value)
}
</script>

<style scoped>
/* 与 WidgetInspector 内 .in-card / .inp 同一套视觉语言，由外层面板统一铺底 */
.compose-widget-list {
  flex-shrink: 0;
}

.cw-card {
  background: rgba(30, 41, 59, 0.42);
  border: 1px solid rgba(71, 85, 105, 0.38);
  border-radius: 8px;
  padding: 10px 10px 8px;
}

.cw-card--muted .cw-empty {
  margin: 0;
}

.cw-card-hd {
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.08em;
  color: #64748b;
  text-transform: uppercase;
  margin: 0 0 8px;
}

.cw-select {
  width: 100%;
  box-sizing: border-box;
  padding: 6px 8px;
  font-size: 12px;
  border-radius: 6px;
  border: 1px solid rgba(71, 85, 105, 0.6);
  background: rgba(30, 41, 59, 0.9);
  color: #e2e8f0;
  cursor: pointer;
}

.cw-select:focus {
  outline: none;
  border-color: rgba(96, 165, 250, 0.55);
  box-shadow: 0 0 0 1px rgba(96, 165, 250, 0.2);
}

.cw-empty {
  margin: 0;
  font-size: 11px;
  color: #64748b;
  line-height: 1.45;
}
</style>
